import React from 'react';
import { IAppPropsWithRoute } from '../../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../../store/modules/appStateSlice';
//import Navbar from '../../shared/Navbar';
import { RootState } from '../../../store/rootReducer';
import { MuiThemeProvider } from '@material-ui/core';
import themeDark from '../../shared/themeDark';
import SubHeader from './SubHeader';
import HospitalPopup from '../../popup/HospitalPopup';
import { filterLocationForPopup, getLocationsDataForPopup } from '../../popup/hospitalPopupHelpers';
import { getRoles } from './calloutResponseHelpers';
import ISelectItem from '../../popup/types/ISelectItem';
import AgedCareCalloutsForManagerWidget from './AgedCareCalloutsForManagerWidget';


interface AgedCareCalloutsForManagerPageProps extends IAppPropsWithRoute {

};

const initialLocation: string[] = [];

const AgedCareCalloutsForManagerPage: React.FC<AgedCareCalloutsForManagerPageProps> = () => {
    const dispatch = useDispatch();
    const { authStore } = useSelector((state: RootState) => state);
    const popState = React.useState(false);
    const locationState = React.useState<ISelectItem[]>([]);
    const [selectedHospital, setSelectedHospital] = React.useState<any>("All Hospitals");
    const [selectedLocations, setSelectedLocations] = React.useState<string[]>(initialLocation);
    const showRules = getRoles(authStore);


    React.useEffect(() => {
        dispatch(showNavbar(true));
        getLocationsData();
    }, [])

    const filterLocation = () => {
        filterLocationForPopup(locationState, setSelectedHospital, setSelectedLocations, null);
    }

    const getLocationsData = async (): Promise<void> => {
        await getLocationsDataForPopup(locationState,
            setSelectedHospital,
            setSelectedLocations,
            selectedLocations,
            null);
    }

    return (
        <>
            <MuiThemeProvider theme={themeDark}>
                <SubHeader showRules={showRules} title={selectedHospital} leftButtonClick={() => popState[1](true)} />
                <HospitalPopup popState={popState} filterLocation={filterLocation} locationState={locationState} />
                <AgedCareCalloutsForManagerWidget
                    selectedLocations={selectedLocations.length === 0 ? initialLocation : selectedLocations}
                    authStore={authStore}
                />
            </MuiThemeProvider>
        </>
    );
}

export default withRouter(AgedCareCalloutsForManagerPage);